import styled from "styled-components"

export const FlexRow = styled.div`
  display: flex;
  margin: auto;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 1rem;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    flex-direction: row;
    margin-bottom: 0;
  `}
`
export const CloseIconWrapper = styled.div`
  padding: ${({theme}) => theme.spacing.half};

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    display: none
  `}
`
